import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";

export type TempBasalType = "off" | "percent" | "Units/hour";

const TEMP_BASAL_TYPES = {
  0: "off",
  1: "percent",
  2: "Units/hour",
} as const;

export type IBFPumpSettings = {
  bolusIncr: number;
  bolusMax: number;
  basalMax: number;
  lowVol: number;
  autoOff: number;
  language: number;
  expireAlert: number;
  bgReminder: number;
  confAlert: number;
  remdrAlert: number;
  serialNumber: string;
  tempBasalType: TempBasalType | undefined;
  extBolType: number;
  bolReminder: number;
  bolCalcs: number;
  bolCalcsReverse: number;
  bgDisplay: number;
  bgSound: number;
  bgMin: number;
  bgGoalLow: number;
  bgGoalUp: number;
  insulinDuration: number;
  alarmRepairCount: number;
  pdmConfig: number;

  units: "mg/dL" | "mmol/L";
};

export const IBF_PUMP_SETTINGS = {
  // Value is just the order in which the items are present in the file
  value: 5,
  name: "IBF_PUMP_SETTINGS",
  size: 114,
  parse: record => {
    record.skip(13);
    const bolusIncr = record.nextUInt32LE() / 100.0;
    const bolusMax = record.nextUInt32LE() / 100.0;
    const basalMax = record.nextUInt32LE() / 100.0;
    const lowVol = record.nextUInt32LE() / 100.0;
    const autoOff = record.nextUInt8();
    const language = record.nextUInt8();
    record.skip(4);
    const expireAlert = record.nextUInt8();
    record.skip(5);
    const bgReminder = record.nextUInt8();
    record.skip(1);
    const confAlert = record.nextUInt8();
    const remdrAlert = record.nextUInt8();
    record.skip(8);
    const serialNumber = record.nextUInt32LE().toString();
    record.skip(19);
    const tempBasType = record.nextUInt8();
    const extBolType = record.nextUInt8();
    const bolReminder = record.nextUInt8();
    const bolCalcs = record.nextUInt8();
    const bolCalcsReverse = record.nextUInt8();
    const bgDisplay = record.nextUInt8();
    const bgSound = record.nextUInt8();
    const bgMin = record.nextUInt16LE();
    const bgGoalLow = record.nextUInt16LE();
    const bgGoalUp = record.nextUInt16LE();
    const insulinDuration = record.nextUInt8() * 30 * 60 * 1000;
    record.skip(19);
    const alarmRepairCount = record.nextUInt8();
    const pdmConfig = record.nextUInt32LE();
    const units = bgDisplay === 0 ? "mg/dL" : "mmol/L";

    return {
      bolusIncr,
      bolusMax,
      basalMax,
      lowVol,
      autoOff,
      language,
      expireAlert,
      bgReminder,
      confAlert,
      remdrAlert,
      serialNumber,
      tempBasalType: TEMP_BASAL_TYPES[tempBasType as 0 | 1 | 2],
      extBolType,
      bolReminder,
      bolCalcs,
      bolCalcsReverse,
      bgDisplay,
      bgSound,
      bgMin,
      bgGoalLow,
      bgGoalUp,
      insulinDuration,
      alarmRepairCount,
      pdmConfig,
      units,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFPumpSettings>;
